import type { ICommune, IParcel } from "@/types/explore"

export const getKaptcherCommuneData = async (codeCom: string): Promise<ICommune> => {
  const res = await fetch(`/api/explore/commune/${codeCom}`)
  if (!res.ok) throw new Error(`Failed to fetch commune data: ${res.status}`)
  return await res.json()
}

export const getKaptcherParcelle = async (idu: string): Promise<Partial<IParcel>> => {
  const res = await fetch(`/api/parcels/${idu}`)
  if (!res.ok) throw new Error(`Failed to fetch parcel data: ${res.status}`)
  return await res.json()
}
